import { AbstractControl, ValidatorFn } from '@angular/forms';

export class PhoneValidator {
	/**
	 * Validate phone number
	 */
	static validatePhone = (): ValidatorFn => {
		return (control: AbstractControl): { [key: string]: boolean } | null => {
			const phoneRegexp = new RegExp(`^[0-9]{9}`);

			if (!control.value) {
				return { phoneRequired: true };
			} else if (control.value && !phoneRegexp.test(control.value)) {
				return { phone: true };
			}

			return null;
		};
	};
}
